import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { LuxonDateTimeParser } from "@/Common/Utilities/DateAndTime/LuxonDateTimeParser";

import styles from "./PopulationBasedFundingEventDetails.module.scss";

interface PopulationBasedFundingEventDetailsProps {
    physicianName: string;
    effectiveDate: Date;
    proposalDate?: Date;
    overrideDate?: Date;
    deregisteredReasonVocabKey?: string;
    proposalReasonVocabKey?: string;
    overrideReasonVocabKey?: string;
    deregistrationOrProposalCustomReason?: string;
    genericReason?: string;
    notes?: string[];
}

function PopulationBasedFundingEventDetails(props: PopulationBasedFundingEventDetailsProps): JSX.Element {
    const { getText } = useTranslation();

    const getNoteWithLineBreaks = (note: string): JSX.Element => {
        const noteWithLinebreaks = note.split("\n").map(line => <p key={line}>{line}</p>);
        return <div key={note}>{noteWithLinebreaks}</div>;
    };

    return (
        <div className={styles.populationBasedFundingEventDetails}>
            <div className={styles.flexContainer}>
                <div className="column-left"><label>{getText("PhysicianNameLabel")}</label></div>
                <div><strong>{props.physicianName}</strong></div>
            </div>

            {props.proposalDate && (
                <div className={styles.flexContainer}>
                    <div><label>{getText("ProposalDateLabel")}</label></div>
                    <div><strong>{LuxonDateTimeParser.parse(props.proposalDate).toFormat("yyyy/LL/dd")}</strong></div>
                </div>
            )}

            {props.proposalReasonVocabKey && (
                <div className={styles.flexContainer}>
                    <div><label>{getText("ProposalReasonLabel")}</label></div>
                    <div><strong>{getText(props.proposalReasonVocabKey)}</strong></div>
                </div>
            )}

            <div className={styles.flexContainer}>
                <div><label>{getText("EffectiveDateLabel")}</label></div>
                <div><strong>{LuxonDateTimeParser.parse(props.effectiveDate).toFormat("yyyy/LL/dd")}</strong></div>
            </div>

            {props.overrideDate && (
                <div className={styles.flexContainer}>
                    <div><label>{getText("OverrideDateLabel")}</label></div>
                    <div><strong>{LuxonDateTimeParser.parse(props.overrideDate).toFormat("yyyy/LL/dd")}</strong></div>
                </div>
            )}

            {props.overrideReasonVocabKey && (
                <div className={styles.flexContainer}>
                    <div><label>{getText("OverrideReasonLabel")}</label></div>
                    <div><strong>{getText(props.overrideReasonVocabKey)}</strong></div>
                </div>
            )}

            {props.deregisteredReasonVocabKey && (
                <div className={styles.flexContainer}>
                    <div><label>{getText("ReasonLabel")}</label></div>
                    <div><strong>{getText(props.deregisteredReasonVocabKey)}</strong></div>
                </div>
            )}

            {props.genericReason && (
                <div className={styles.flexContainer}>
                    <div><label>{getText("ReasonLabel")}</label></div>
                    <div><strong>{getText(props.genericReason)}</strong></div>
                </div>
            )}

            {props.deregistrationOrProposalCustomReason && (
                <div className={styles.flexContainer}>
                    <div><label>{getText("CommentLabel")}</label></div>
                    <div className={styles.commentsContainer}><strong>{props.deregistrationOrProposalCustomReason}</strong></div>
                </div>
            )}

            {props.notes?.any() && (
                <div className={styles.flexContainer}>
                    <div><label>{getText("NotesLabel")}</label></div>
                    <div className={styles.notesContainer}>
                        {props.notes.map(note => getNoteWithLineBreaks(note))}
                    </div>
                </div>
            )}
        </div>
    );
}

export { PopulationBasedFundingEventDetails };
